import script from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewMapping.vue?vue&type=script&setup=true&lang=js"

import "./ReviewMapping.vue?vue&type=style&index=0&id=1b25af19&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b25af19"]])

export default __exports__